import styled from "styled-components";
import Typography from "components/Typography";

export const TitleLabel = styled(Typography)`
  line-height: 24px;
`;
